<template>
    <v-container>
        <Toolbar></Toolbar>
        <v-layout row wrap>
            <v-flex>
                <div class="display-3 mt-5 middle ml-2 mr-2">{{ $t("pageNotFound.pageNotFoundTitle") }}</div>
                <div class="mt-2 middle ml-2 mr-2">
                    <br />
                    <br />{{ $t("pageNotFound.pageNotFoundText") }}
                </div>
                <div class="middle mt-3">
                    <br />
                    <br />
                    <v-btn id="goToHomeButton" color="primary" width="200" @click="goToHome()"> {{ $t("pageNotFound.goToHome") }} </v-btn>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<style lang="scss" scoped>
.middle {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<script>
import Utils from "../utils";
import Toolbar from "../components/toolbar/Toolbar.vue";

export default {
    name: "PageNotFound",
    components: { Toolbar },
    props: {},
    computed: {},
    async mounted() {},
    methods: {
        goToHome() {
            this.$router.push(Utils.getRedirectToPortalOrWelcome(this.$user));
        }
    }
};
</script>
